export default __webpack_public_path__ + "static/media/2 Pairs.e5117e92.mp3";